import React, { useEffect } from 'react';
import Microapp from '@/components/micro-app';
import env from '@/env';
import { getUrlObject } from '@/common/utils/browser';
import { formatQueryObj } from '@/common/utils';
import history from '@/history';

function MicroDrawer({ id, visible }) {
  useEffect(() => {
    if (visible) {
      window.history.replaceState(
        history.state,
        null,
        location.pathname + location.search + `#/embed-page/compass?jid=${id}`
      );
    } else {
      window.history.replaceState(history.state, null, location.pathname + location.search + '#/integration');
    }
  }, [visible, id]);
  // useEffect(() => {
  //   if (!id) return;
  //   //变参数
  //   const obj = getUrlObject();
  //   obj.jid = id;
  //   const search = '?' + formatQueryObj(obj);

  //   history.replace(window.location.pathname + window.location.search + window.location.hash + `?jid=${id}`);
  // }, [id]);
  return (
    <Microapp
      name={`category-inventory-detail`}
      data={{ jid: id }}
      url={`//${env.WAREOPS_DOMAIN}/#/embed-page/compass?jid=345074`}
    />
  );
}

export default MicroDrawer;
